"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishEventPlugin = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const useFindEventNames_1 = require("../../hooks/useFindEventNames");
const StyledConfiguratorDiv = styled_components_1.default.div `
  .instructions {
    margin: 24px 0 16px 0;
  }
`;
const PublishEventConfigurator = props => {
    var _a;
    const { taskTypeId, onChange } = props;
    const [invoke, setInvoke] = (0, react_1.useState)(props.invoke);
    const { eventList, isLoading, error, findEvents } = (0, useFindEventNames_1.useFindEventNames)(taskTypeId || 0);
    (0, react_1.useEffect)(() => {
        findEvents();
    }, [findEvents]);
    return (react_1.default.createElement(StyledConfiguratorDiv, null,
        react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: 'body2', className: 'instructions' }, "Configure a server side event to be published when entering into this workflow state. Each workflow entity will have different events that can be configured."),
        react_1.default.createElement(lab_1.Autocomplete, { multiple: true, className: 'field', filterSelectedOptions: true, loading: isLoading, options: eventList || [], value: ((_a = invoke.data) === null || _a === void 0 ? void 0 : _a.events) || [], getOptionLabel: option => option.description, onChange: (_, value) => {
                const updatedInvoke = Object.assign(Object.assign({}, invoke), { data: { events: value } });
                setInvoke(updatedInvoke);
                onChange === null || onChange === void 0 ? void 0 : onChange(updatedInvoke);
            }, renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { variant: 'outlined', label: 'Events', placeholder: 'Select event', error: !!error, helperText: error === null || error === void 0 ? void 0 : error.message }))) })));
};
const StyledDisplayDiv = styled_components_1.default.div `
  font-size: 13px;
  padding-left: 4px;
  text-indent: -4px;
  code {
    background: #f4f5fa;
    padding: 2px 5px;
    border-radius: 3px;
  }
  b {
    padding: 0 5px 0 0;
  }
`;
const PublishEventDisplay = props => {
    var _a, _b;
    const data = (_a = props.invoke) === null || _a === void 0 ? void 0 : _a.data;
    return (react_1.default.createElement(StyledDisplayDiv, null, (_b = data === null || data === void 0 ? void 0 : data.events) === null || _b === void 0 ? void 0 : _b.map((event, index) => (react_1.default.createElement("div", { key: index, className: 'line' }, event.description || event.event)))));
};
function findEventNames(taskTypeId) {
    const request = core_ui_1.api.get(`workflows/event-names/${taskTypeId}`, {});
    return { request, result: (0, core_ui_1.apiResolve)(request) };
}
exports.PublishEventPlugin = {
    src: 'publishEvent',
    name: 'Publish Event',
    configurator: PublishEventConfigurator,
    display: PublishEventDisplay,
    validate: () => true,
    validateImport: (condition, context) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { taskTypeId } = context;
        const invoke = condition;
        const events = Array.isArray((_a = invoke === null || invoke === void 0 ? void 0 : invoke.data) === null || _a === void 0 ? void 0 : _a.events)
            ? (_b = invoke.data) === null || _b === void 0 ? void 0 : _b.events
            : [];
        const { data = [], error } = yield findEventNames(taskTypeId).result;
        if (error) {
            return {
                severity: 'warning',
                message: `${error.error || 'Error'}: ${error.message || 'An error occurred.'}`
            };
        }
        const invalidEvents = events.filter(event => !data.some(item => item.event === event.event));
        if (invalidEvents.length === 0) {
            return;
        }
        const all = invalidEvents
            .map(item => {
            const { event, description } = item;
            const entity = (0, lodash_1.startCase)(event.slice(0, event.indexOf('.')));
            const name = entity && ` (${entity})`;
            return `"${description + name}"`;
        })
            .join(', ');
        return {
            severity: 'error',
            message: `Invalid events found: ${all}.` +
                ' Fix issue by removing or reselecting the events.'
        };
    }),
    service: (state, params) => {
        console.log('publishEvent state, params', state, params);
        return true;
    }
};
//# sourceMappingURL=PublishEventPlugin.js.map